import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Users, BarChart3, BellRing, UserCog, History, Eye, ArrowLeft, Store, Palette, Building2 } from 'lucide-react';
import AppShell from './AppShell';
import { useT } from '../i18n/I18nProvider';
import { useSession } from '../session/SessionProvider';
import { Avatar, Badge, Button } from '../ui';

export default function CompanyLayout() {
  const t = useT();
  const navigate = useNavigate();
  const { company, isViewer, isViewingAsOwner, exitCompany } = useSession();

  const nav = [
    {
      group: t('nav.groups.company'),
      items: [
        { to: '/company', end: true, label: t('nav.home'), icon: Home },
        { to: '/company/employees', label: t('nav.employees'), icon: Users },
        { to: '/company/analytics', label: t('nav.analytics'), icon: BarChart3 },
      ],
    },
    {
      group: t('nav.groups.engagement'),
      items: [
        { to: '/company/notifications', label: t('nav.notifications'), icon: BellRing },
      ],
    },
    {
      group: t('nav.groups.settings'),
      items: [
        { to: '/company/venues', label: t('nav.restaurants'), icon: Store },
        { to: '/company/branding', label: t('nav.branding'), icon: Palette },
        { to: '/company/profile', label: t('nav.myCompany'), icon: Building2 },
        { to: '/company/team', label: t('nav.team'), icon: UserCog },
        { to: '/company/audit', label: t('nav.audit'), icon: History },
      ],
    },
  ];

  const brand = (
    <div className="flex min-w-0 items-center gap-2.5">
      <Avatar name={company?.name} size="md" className="rounded-lg" />
      <div className="min-w-0 leading-tight">
        <p className="truncate text-sm font-semibold text-zinc-900 dark:text-zinc-50">{company?.name}</p>
        <p className="truncate text-[11px] text-zinc-500 dark:text-zinc-400">
          {t('app.companyCabinet')}{company?.company_code ? ` · ${company.company_code}` : ''}
        </p>
      </div>
    </div>
  );

  // Владелец смотрит кабинет компании — заметная плашка с возвратом в консоль
  const banner = isViewingAsOwner ? (
    <div className="flex items-center justify-between gap-3 bg-brand-600 px-4 py-2 text-sm text-white sm:px-6">
      <span className="flex min-w-0 items-center gap-2">
        <Eye className="h-4 w-4 shrink-0" />
        <span className="truncate">{t('viewAs.banner', { name: company?.name })}</span>
      </span>
      <button
        type="button"
        onClick={() => { exitCompany(); navigate('/owner/companies'); }}
        className="flex shrink-0 items-center gap-1.5 rounded-md bg-white/15 px-2.5 py-1 text-xs font-medium hover:bg-white/25"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        {t('viewAs.exit')}
      </button>
    </div>
  ) : null;

  const topbarExtra = isViewer ? (
    <Badge tone="warning" dot>{t('common.readOnly')}</Badge>
  ) : isViewingAsOwner ? (
    <Button variant="ghost" size="sm" icon={ArrowLeft} onClick={() => { exitCompany(); navigate('/owner'); }} className="hidden sm:inline-flex">
      {t('app.ownerConsole')}
    </Button>
  ) : null;

  return <AppShell nav={nav} brand={brand} banner={banner} topbarExtra={topbarExtra} />;
}
